import React from 'react';
import * as S from './styles';
import { Button } from 'components/Atoms';
import flag from 'assets/images/Pop/popeyesFlag.svg';
import * as T from './interfaces';

export const RequestLocation = ({
  id,
  onRequestLocation,
}: T.IRequestLocationPorps) => (
  <S.RequestLocationWrapper id={id} data-testid={id}>
    <img src={flag} alt="Bandeira com a escrita POPEYES" />
    <span>Encontrar o Popeyes mais próximo de você.</span>
    <Button
      type="button"
      id={id}
      title="acionar para solicitar localização"
      onClick={onRequestLocation}
    >
      Usar minha localização
    </Button>
  </S.RequestLocationWrapper>
);
